import type { ApartmentType, BillingAddress, ProfileTypeEnum } from "../../apiTypes";
import type { GetUserProfileQuery } from "../queries/User.generated";

export type UserDTO = {} & Partial<GetUserProfileQuery["getMyProfile"]>;

// TODO get rid of this
export type Property = {
  propertyId: string;
  city: string;
  streetAddress1: string;
  streetAddress2: string;
  name: string;
  notes: string;
  homeType: ApartmentType;
  isDefault: boolean;
  postalOrZipCode: string;
  floorArea: number;
  localizationId: string;
  doorCode: string;
};

export type Customer = {
  id: string;
  virtualWalletBalance: number;
  email: string;
  firstName: string;
  lastName: string;
  notifications: {
    pushNotifications: boolean;
    smsNotifications: boolean;
    newsletterNotifications: boolean;
  };
  profile: {
    avatar: string;
    dateOfBirth: string;
    description: string;
    phoneNumber: string;
    profileType: ProfileTypeEnum;
  };
  properties: Property[];
  invoiceData: BillingAddress | null;
};

export const initialCustomerState = {
  id: "",
  virtualWalletBalance: 0,
  email: "",
  firstName: "",
  lastName: "",
  notifications: {
    pushNotifications: true,
    smsNotifications: true,
    newsletterNotifications: true,
  },
  profile: {
    avatar: "",
    dateOfBirth: "",
    description: "",
    phoneNumber: "",
    profileType: "CUSTOMER",
  },
  properties: [],
  invoiceData: {
    city: "",
    country: "",
    email: "",
    line1: "",
    line2: "",
    name: "",
    postal_code: "",
    state: "",
    taxIdentification: null,
  },
} as Customer;

export const parseCustomerDTO = (
  userDTO: Partial<GetUserProfileQuery["getMyProfile"]>,
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TODO: Refactor
): Customer => {
  const parsedProperties =
    userDTO?.profileInformation?.customerMetadata?.properties?.map((property) => ({
      propertyId: property.id,
      city: property.city,
      streetAddress1: property.streetAddress1,
      streetAddress2: property.streetAddress2 || "",
      name: property.name || "",
      notes: property.notes || "",
      doorCode: property.doorCode || "",
      homeType: property.type,
      isDefault: property.isCustomerDefault,
      postalOrZipCode: property.postalOrZipCode,
      floorArea: property.floorArea,
      localizationId: property.localizationId || "",
    })) || [];

  return {
    id: userDTO.id || "",
    virtualWalletBalance: initialCustomerState?.virtualWalletBalance,
    email: userDTO?.profileInformation?.email || "",
    firstName: userDTO?.profileInformation?.firstName || "",
    lastName: userDTO?.profileInformation?.lastName || "",
    notifications: {
      pushNotifications:
        userDTO?.profileInformation?.pushNotifications !== undefined
          ? !!userDTO?.profileInformation?.pushNotifications
          : initialCustomerState?.notifications?.pushNotifications,
      smsNotifications:
        userDTO?.profileInformation?.smsNotifications !== undefined
          ? !!userDTO.profileInformation.smsNotifications
          : initialCustomerState.notifications.smsNotifications,
      newsletterNotifications:
        userDTO?.profileInformation?.newsletterNotifications !== undefined
          ? !!userDTO.profileInformation.newsletterNotifications
          : initialCustomerState.notifications.newsletterNotifications,
    },
    profile: {
      avatar: userDTO?.profileInformation?.image || "",
      dateOfBirth: userDTO?.profileInformation?.dateOfBirth || "",
      description: userDTO?.profileInformation?.description || "",
      phoneNumber: userDTO?.profileInformation?.phone || "",
      profileType:
        userDTO?.profileInformation?.profileType || initialCustomerState?.profile?.profileType,
    },
    properties: parsedProperties,
    invoiceData: {
      country: userDTO?.profileInformation?.customerMetadata?.invoiceData?.country || "",
      name: userDTO?.profileInformation?.customerMetadata?.invoiceData?.name || "",
      email: userDTO?.profileInformation?.customerMetadata?.invoiceData?.email || "",
      city: userDTO?.profileInformation?.customerMetadata?.invoiceData?.city || "",
      line1: userDTO?.profileInformation?.customerMetadata?.invoiceData?.line1 || "",
      line2: userDTO?.profileInformation?.customerMetadata?.invoiceData?.line2 || "",
      postal_code: userDTO?.profileInformation?.customerMetadata?.invoiceData?.postal_code || "",
      state: userDTO?.profileInformation?.customerMetadata?.invoiceData?.state || "",
      taxIdentification:
        userDTO?.profileInformation?.customerMetadata?.invoiceData?.taxIdentification || "",
    },
  };
};
